import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        supportedLngs: ['en_GB', 'en_US',
            'fr_FR', 'fr_BE',
            'nl_NL', 'nl_BE',
            'de_DE', 'de_BE'],
        fallbackLng: 'en_GB',
        backend: {
            loadPath: "/locales/onboarding/{{lng}}.json",
            allowMultiLoading: true,

        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: true
        },
        load: "currentOnly"
    });


export default i18n

export function changeLang(lang: string) {
    return i18n.changeLanguage(lang)
}
